import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";

import {
  applicantFaceLivenessFinish,
  applicantFaceLivenessStart,
} from "@api/applicants";

import { useStoreContext } from "@context";

import Message from "@shared/services/message";

export const facelivenessKeys = {
  all: ["faceliveness"] as const,
  start: () => [...facelivenessKeys.all, "start"] as const,
  finish: () => [...facelivenessKeys.all, "finish"] as const,
};

interface UseFaceLivenessStartProps {
  onAlreadyVerified: () => void;
}

export const useFaceLivenessStart = ({
  onAlreadyVerified,
}: UseFaceLivenessStartProps) => {
  const { applicantExamId } = useStoreContext();
  const mutation = useMutation({
    mutationKey: facelivenessKeys.start(),
    mutationFn: () =>
      applicantFaceLivenessStart({
        applicantExamId: applicantExamId || 0,
      }),
    onError: (err: string) => {
      // 409 means the user already verified in a previous session
      if (typeof err === "string" && err?.includes?.("409")) {
        onAlreadyVerified();
      } else {
        toast.error(Message.getMessageByKey("liveness.serverHeaderText"));
      }
    },
  });

  return mutation;
};

export const useFaceLivenessFinish = () => {
  const { applicantExamId } = useStoreContext();

  const mutation = useMutation({
    mutationKey: facelivenessKeys.finish(),
    mutationFn: ({ sessionId }: { sessionId: string }) =>
      applicantFaceLivenessFinish({
        applicantExamId,
        sessionId,
      }),
  });

  return mutation;
};
